/**
 * URL生成のための引数を定義するインターフェース
 */
interface GetJobDetailHrefArgs {
  /** 求人ID */
  jid: string;
  /** 閲覧済みの求人かどうかのフラグ */
  isRead: boolean;
  /** 特集枠ID */
  featuredId: string;
}

/**
 * 特集枠求人一覧求人カードの遷移先URLを生成して返す関数
 *
 * @param {GetJobDetailHrefArgs} param - 引数オブジェクト
 * @param {string} param.jid - 求人ID
 * @param {boolean} param.isRead - 閲覧済みの求人かどうかのフラグ
 * @param {string} param.featuredId - 特集枠ID
 * @returns {string} 求人カードの遷移先URL
 */
export const getFeaturedJobDetailHref = ({
  jid,
  isRead,
  featuredId,
}: GetJobDetailHrefArgs) => {
  const from = isRead ? 'browsed' : 'item';

  return `/DodaFront/View/JobSearchDetail/j_jid__${jid}/-fm__tokushu/-tp__1/-mtmd__/-fid__${featuredId}/?from=list_${from}`;
};
